import React,{ useState,useEffect,useRef } from 'react';
import { useAlert } from '../../../context/AlertContext';
import { useReactToPrint } from 'react-to-print';
import clientServices from '../clientServices';
import moment from 'moment';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Print } from '@mui/icons-material';
import { useAppData } from '../../../context/AppDataContext';

const LabelValue = ({label,value}) =>{
    return (
        <div className='row'>
            <div className='col-6 fw-bold'>{label}</div>
            <div className='col-6'> : {value}</div>
        </div>
    )
}

const LabelValue1 = ({label,value}) =>{
    return(
        <>
            {value !== "" && value!==null &&
                <div className='row'>
                    <div className='col-6'>
                        <span className='fw-bold'>{label}</span>
                    </div>
                    <div className='col-6'>
                        <span className='fw-bold'> : {value}</span>
                    </div>
                </div>
            }   
        </>
    )
}





const ClientDetailsComponent = ({clientDetails}) =>{
  const [dialogStatus,setDialogStatus] = useState(false);
  const printComponentRef = useRef();
  
  
  const {defaultClinic} = useAppData();

  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
    //pageStyle:"@page { size: 2.5in 2.5in; margin: 0; padding:0 }, @media print { @page {  size: 2.5in 2.5in margin: 0mm !important;  body,html{padding:0px;margin:0px;} } }",
    //pageStyle:"@media print { html, body { height: 2.5in; /* Use 100% here to support printing more than a single page*/ margin: 0 !important;padding: 0 !important;overflow: hidden;}}; @page { size: 2.5in 2.5in; margin: 0; }"
    //onAfterPrint:()=>{navigate("/kiosk/dashboard")}
  });

  return (
    clientDetails &&
    <>
      <Dialog
        open={dialogStatus}
        keepMounted
        onClose={()=>{setDialogStatus(false)}}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle>
          <div className='d-flex justify-content-between'>
            <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >Close</button>
            <h3>Print Preview</h3>
            <button className='btn btn-primary float-end' onClick={handlePrint}>Print </button>
          </div>
        </DialogTitle>
        <DialogContent className='border'>
          <div className='p-3 my-3' ref={printComponentRef}>
            
            {defaultClinic && 
              <div className='row mb-2'>                 
                <div className='col-6'>
                  {defaultClinic.logo && defaultClinic.logo !== null ?
                      <img className='shadow-lg' src={defaultClinic.logo} style={{maxHeight:60, width:"auto"}} />
                      :
                      <h3>{defaultClinic.title}</h3>
                  }                        
                </div>
                <div className='col-6'>
                  <span className='float-end'>
                    <table style={{pageBreakAfter:"avoid"}}>
                      <tr>
                          <td><span className='fw-bold me-2'>Date : {moment().format("LL")}</span></td>
                          <td></td>
                      </tr>
                      <tr>
                          <td><span className='fw-bold'>Patient Id : </span></td>
                          <td>{clientDetails && <span className='barcode'>*{clientDetails.id}*</span> }
                          </td>
                      </tr>
                    </table>
                    <div></div>
                    <div></div>
                  </span>
                </div>
              </div>
            }
            {clientDetails &&
              <div className='row'>
                <hr className='m-1'/>
                <div className='col-6'>
                  <LabelValue1 label={"Patient Name"} value={clientDetails.firstName}/>
                  <LabelValue1 label={"Age"} value={clientDetails.age}/>
                  {clientDetails.dob && <LabelValue1 label={"DOB"} value={ moment(clientDetails.dob).format("LL")}/> }
                </div>
                <div className='col-6'>
                  <LabelValue1 label={"Phone"} value={clientDetails.phone}/>
                  <LabelValue1 label={"Address"} value={clientDetails.address}/>
                  {clientDetails.uid!== null && <LabelValue1 label={"File Id"} value={clientDetails.uid}/> }
                </div>
                <hr className='m-2' />
              </div>
            }
          </div>
        </DialogContent>
      </Dialog>

      <div className='card'>
        <div className='card-body'>
          <div className='row'>
            <div className='col-md-6'>
              <LabelValue label={"Name"}  value={clientDetails.firstName} />
              <LabelValue label={"Phone"}  value={clientDetails.phone} />
              <LabelValue label={"Patient Id"}  value={clientDetails.id} />
              {clientDetails.uid !== null && <LabelValue label={"File Id"}  value={clientDetails.uid} /> }
            </div>
            <div className='col-md-6'>
              {clientDetails.gender !== null ?
                  <LabelValue label={"Gender"}  value={clientDetails.gender == 1 ? "Male" : "Female"} />
                  :
                  <LabelValue label={"Gender"}  value={"N.A"} />
              }
              <LabelValue label={"Age"}  value={clientDetails.age} />
              <LabelValue label={"DOB"}  value={clientDetails.dob} />        
            </div>
          </div>
        </div>
          <div className='card-header p-0'>
            <button className='btn btn-primary float-end' onClick={()=>setDialogStatus(true)}><Print/> Print OPD Slip</button>
          </div>
        </div>
    </>
  )
}

export default ClientDetailsComponent